module.exports = __webpack_public_path__ + "static/media/i-hate-it-here.b4a9a0e7.mp3";